import {UndoableAction} from "./UndoableAction";

export class UndoManager {
    private executedActions: UndoableAction[] = [];

    resetState() {
        this.executedActions = [];
    }

    public execute(action: UndoableAction) {
        this.executedActions.push(action);
        return action.execute();
    }

    public undo(action: UndoableAction) {
        this.executedActions = this.executedActions.filter(executedAction => executedAction !== action);
        return action.undo();
    }

    public undoLatest() {
        const latestAction = this.executedActions.pop();
        return latestAction?.undo();
    }
}

export const undoManager = new UndoManager();
